import React from 'react';
import Box from 'sail/Box';
import {ButtonLink} from 'sail/Button';
import {defineMessages, FormattedMessage} from 'react-intl';
import {useGuide} from '../../data/GuideProvider';

const messages = defineMessages({
  sample: {
    id: 'docsApp.integrationBuilder.response.sample',
    description: 'Sample response label',
    defaultMessage: 'Sample response from Stripe',
  },
});

// Displays a pop-up window with a sample Stripe response
export default ({show, handleClose}) => {
  const {activeStep} = useGuide();
  const ref = React.useRef();

  const active = !!(activeStep && activeStep.response);

  React.useLayoutEffect(() => {
    if (active) {
      window.Prism.highlightElement(ref.current);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ // TODO: use correct dependencies
  }, []);

  if (!active) {
    return null;
  }

  return (
    <Box
      flex={{direction: 'column'}}
      style={{
        height: show ? 'calc(100% - 72px)' : '0px',
        opacity: show ? '1' : '0',
        transition:
          'height 0s ease-in-out, transform 0.2s ease-in-out, opacity 0.2s ease-in-out',
        transform: show ? 'translateY(0px)' : 'translateY(40px)',
        border: show ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
        borderRadius: '6px',
        position: 'absolute',
        zIndex: 2,
        background: '#212D63',
        bottom: '10px',
        left: '10px',
        width: 'calc(100% - 20px)',
      }}
      className="Response-panel"
    >
      <Box
        padding={{top: 20, right: 20, left: 20, bottom: 0}}
        flex={{justifyContent: 'flex-start', alignItems: 'center'}}
      >
        <ButtonLink
          icon="cancel"
          iconPosition="left"
          size="small"
          color="blue"
          label={<FormattedMessage {...messages.sample} />}
          onClick={(evt) => {
            handleClose(false);
          }}
          style={{
            marginTop: 0,
            marginRight: 0,
            padding: 0,
            paddingBottom: '12px',
            display: show ? 'inline-flex' : 'none',
          }}
        />
      </Box>
      <Box
        padding={{horizontal: 24, vertical: 12}}
        style={{
          overflowY: 'scroll',
        }}
      >
        <pre
          style={{
            background: '#212D63',
            lineHeight: '18px',
            fontSize: 13,
          }}
        >
          <code
            ref={ref}
            className="language-json"
            style={{padding: 0, fontSize: '13px', color: '#f5fbff'}}
          >
            {JSON.stringify(activeStep.response, null, 4)}
          </code>
        </pre>
      </Box>
    </Box>
  );
};
